import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment-taxi-directo'

import { HttpClient } from "@angular/common/http"
import { Usuario } from '../clases/usuario';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private usuario$: BehaviorSubject<Usuario[]> = new BehaviorSubject<Usuario[]>([]);

  constructor(private _http: HttpClient) { }

  obtenerCliente(id: number) { //idEmpresa: number, idCentroCosto: number, idUsuario: number
    const url = environment.URL_BASE + "clienteAuthorization/obtenerCliente?id=" + id;
    return this._http.get(url);
  }

  centroCosto(IdEmpresa: any) {
    const url = environment.URL_BASE + 'centrocostoAuthorization/getempresa' + "?id=" + IdEmpresa
    return this._http.get(url)
  }

  centroCostoAsociado(strData){
    const url = environment.URL_BASE + 'centrocostoAuthorization/ObtenerCCXCliente';
    return this._http.post(url,strData)
  }

  centroCostoSinAutetication(IdEmpresa: any) {
    const url = environment.URL_BASE + 'centrocosto/getempresa' + "?id=" + IdEmpresa
    return this._http.get(url)
  }

  empresa(id: number) {
    const url = environment.URL_BASE + 'empresaAuthorization/all' + "?id=" + id
    return this._http.get(url)
  }

  getEmpresaById(id: number) {
    const url = environment.URL_BASE + 'empresaAuthorization/get' + "?id=" + id
    return this._http.get(url)
  }

  compania(id: number) {
    const url = environment.URL_BASE + 'compañiaAuthorization/all' + "?id=" + id
    return this._http.get(url)
  }

  perfil(idUsuario: number) {
    const url = environment.URL_BASE + 'rolAuthorization/all' + "?id=" + idUsuario
    return this._http.get(url)
  }


  listarUsuarios(obj: any) {
    const url = environment.URL_BASE + 'clienteAuthorization/filter';
    return this._http.post(url, obj).pipe(
      map((res: any) => {
        this.usuario$.next(res.data);
        return res;
      })
    )
  }

  getUsuarios() {
    //console.log(this.usuario$, ["GET USUARIOS SERVICE"]);

    return this.usuario$;
  }

  getUsuario(id: number | string) {
    //console.log("get Usuario");

    return this.getUsuarios().pipe(
      map(listaUsuarios => listaUsuarios.find(usuario => usuario.IdCliente === +id))
    );
  }

  GuardarUsuario(usuario: Usuario) {
    const url = environment.URL_BASE + 'clienteAuthorization/save'
    return this._http.post(url, usuario)
  }

  listarArea(IdEmpresa: any) {
    const url = environment.URL_BASE + 'clienteAuthorization/listarArea' + "?idEmpresa=" + IdEmpresa
    return this._http.get(url)
  }

  listarSupervisor(IdEmpresa: any, IdCentroCosto: any, busqueda: string) {
    const url = environment.URL_BASE + "clienteAuthorization/getSupervisoresAutocomplete?idEmpresa=" + IdEmpresa + "&idCentroCosto=" + IdCentroCosto
      + "&busqueda=" + busqueda
    return this._http.get(url)
  }

  listarSupervisorEmpresa(idEmpresa: any){
    const url = environment.URL_BASE+ "clienteAuthorization/getSupervisorEmpresas?idEmpresa=" + idEmpresa
    return this._http.get(url);
  }

  saldo(idCliente) {
    const url = environment.URL_BASE + "presupuestoAuthorization/saldo?idCliente=" + idCliente;
    return this._http.get(url)
  }

  obtenerIdConductor(idConductor:string){
    const url = environment.URL_BASE + "ConductorAuthorization/getConductor?idConductor=" + idConductor;
    return this._http.get(url)
  }

  obtenerListaIdConductor(idConductor:string){
    const url = environment.URL_BASE + "ConductorAuthorization/all?idConductor=" + idConductor;
    return this._http.get(url)
  }

  exportExcel(idEmpresa: number): Observable<Blob> {
    const url = environment.URL_REPORTE + 'reportes/usuarios?idEmpresa=' + idEmpresa;

    return this._http.get(url, { responseType: 'blob' }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));
  }

  exportExcelFiltros(data: any): Observable<Blob> {
    const url = environment.URL_REPORTE + 'reportes/usuariosTodos';

    return this._http.post(url, data, { responseType: 'blob' }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));
  }

  cambiarEstadoUsuarios(data: any) {
    const url = environment.URL_BASE + "clienteAuthorization/desactivarCliente";
    return this._http.post(url, data)
  }

  listarPresupuestoDisponible(id: number) {
    const url = environment.URL_BASE + 'presupuestoAuthorization/AvalibleClient' + "?id=" + id;
    return this._http.get(url)
  }

  auditoria(data: any){
    const url = environment.URL_BASE + 'ClienteAuthorization/AuditoriaCliente';
    return this._http.post(url, data)
  }

  recuperarClave(data: any){
    const url = environment.URL_BASE + 'ClienteAuthorization/RestablecerClave';
    return this._http.post(url,data)
  }

  recuperarClaveUsuario(data: any){
    const url = environment.URL_BASE + 'UsuarioAuthorization/RestablecerClave';
    return this._http.post(url,data)
  }

  recuperarTelefono(data: any){
    const url = environment.URL_BASE + 'ClienteAuthorization/RestablecerTelefono';
    return this._http.post(url,data)
  }

  exportExcelAuditoria(data: any): Observable<Blob> {
    const url = environment.URL_BASE + 'TaxiDirectoReporte/descargarReporteAuditoriaCliente';

    return this._http.post(url, data, { responseType: 'blob' }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));
  }

  getColumnasCliente(){
    const url = environment.URL_BASE + 'ClienteAuthorization/ColumnasCliente';
    return this._http.get(url)
  }

  saveDatosReporteUsuario(data: any){
    const url = environment.URL_BASE + 'ClienteAuthorization/SaveDatosReporteUsuarios';
    return this._http.post(url, data);
  }

}
